<template>
  <base-icon-button :title="title"
                    v-on="$listeners">
    <base-material-design-icon :icon="icon"/>
  </base-icon-button>
</template>

<script>
  import BaseIconButton from '@/components/base-components/base-icons/BaseIconButton';
  import BaseMaterialDesignIcon from '@/components/base-components/base-icons/BaseMaterialDesignIcon';

  export default {
    name: 'BaseMaterialDesignIconButton',
    components: { BaseMaterialDesignIcon, BaseIconButton },
    props: {
      icon: {
        type: String,
        required: true,
      },
      title: {
        type: String,
        required: true,
      },
    },
  };
</script>

<style scoped>

</style>
